module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-space"
  }, [(_vm.showModal) ? _c('collectModal', {
    attrs: {
      "collect": _vm.collectInfo,
      "contact": _vm.contactInfo,
      "ill": _vm.familyInfo,
      "history": _vm.history
    },
    on: {
      "close": _vm.resetCollect,
      "submitData": _vm.submitCase
    }
  }) : _vm._e(), _vm._v(" "), _c('mu-flexbox', {
    staticClass: "box-margin",
    attrs: {
      "align": "flex-start"
    }
  }, [_c('mu-flexbox-item', {
    staticClass: "item-margin"
  }, [_c('mu-flexbox', {
    staticStyle: {
      "margin-left": "40px"
    },
    attrs: {
      "orient": "vertical"
    }
  }, [_c('mu-flexbox-item', {
    staticClass: "item-margin"
  }, [_c('li', {
    staticClass: "oddStyle"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('li', {
    staticClass: "evenStyle"
  }, [_vm._v(_vm._s(_vm.collectInfo.name))])]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "item-margin"
  }, [_c('li', {
    staticClass: "oddStyle",
    staticStyle: {
      "margin-top": "0"
    }
  }, [_vm._v("性别")]), _vm._v(" "), _c('li', {
    staticClass: "evenStyle"
  }, [_vm._v(_vm._s(_vm.sex))])]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "item-margin"
  }, [_c('li', {
    staticClass: "oddStyle"
  }, [_vm._v("教育程度")]), _vm._v(" "), _c('li', {
    staticClass: "evenStyle"
  }, [_vm._v(_vm._s(_vm.edu))])]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "item-margin"
  }, [_c('li', {
    staticClass: "oddStyle"
  }, [_vm._v("现居住地")]), _vm._v(" "), _c('li', {
    staticClass: "evenStyle"
  }, [_vm._v(_vm._s(_vm.place))])]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "item-margin"
  }, [_c('li', {
    staticClass: "oddStyle"
  }, [_vm._v("当前职业")]), _vm._v(" "), _c('li', {
    staticClass: "evenStyle"
  }, [_vm._v(_vm._s(_vm.collectInfo.currentJob))])])], 1)], 1), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "item-margin"
  }, [_c('mu-flexbox', {
    staticStyle: {
      "margin-left": "40px"
    },
    attrs: {
      "orient": "vertical"
    }
  }, [_c('mu-flexbox-item', {
    staticClass: "item-margin"
  }, [_c('li', {
    staticClass: "oddStyle"
  }, [_vm._v("工作单位")]), _vm._v(" "), _c('li', {
    staticClass: "evenStyle"
  }, [_vm._v(_vm._s(_vm.collectInfo.workspace))])]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "item-margin"
  }, [_c('li', {
    staticClass: "oddStyle"
  }, [_vm._v("出生日期")]), _vm._v(" "), _c('li', {
    staticClass: "evenStyle"
  }, [_vm._v(_vm._s(_vm.collectInfo.birthday))])]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "item-margin"
  }, [_c('li', {
    staticClass: "oddStyle"
  }, [_vm._v("家庭住址")]), _vm._v(" "), _c('li', {
    staticClass: "evenStyle"
  }, [_vm._v(_vm._s(_vm.family))])]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "item-margin"
  }, [_c('li', {
    staticClass: "oddStyle"
  }, [_vm._v("婚姻状态")]), _vm._v(" "), _c('li', {
    staticClass: "evenStyle"
  }, [_vm._v(_vm._s(_vm.marry))])]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "item-margin"
  }, [_c('li', {
    staticClass: "oddStyle"
  }, [_vm._v("曾经职业")]), _vm._v(" "), _c('li', {
    staticClass: "evenStyle"
  }, [_vm._v(_vm._s(_vm.collectInfo.previousJob))])])], 1)], 1)], 1), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('mu-flexbox', {
    staticClass: "box-margin",
    attrs: {
      "align": "flex-start"
    }
  }, [_c('mu-flexbox-item', {
    staticClass: "item-margin"
  }, [_c('mu-flexbox', {
    staticStyle: {
      "margin-left": "40px"
    },
    attrs: {
      "orient": "vertical"
    }
  }, [_c('mu-flexbox-item', {
    staticClass: "item-margin"
  }, [_c('li', {
    staticClass: "oddStyle",
    staticStyle: {
      "margin-top": "0"
    }
  }, [_vm._v("联系人")]), _vm._v(" "), _c('li', {
    staticClass: "evenStyle"
  }, [_vm._v(_vm._s(_vm.contactInfo.contacts))])]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "item-margin"
  }, [_c('li', {
    staticClass: "oddStyle"
  }, [_vm._v("联系电话")]), _vm._v(" "), _c('li', {
    staticClass: "evenStyle"
  }, [_vm._v(_vm._s(_vm.contactInfo.telephone))])])], 1)], 1), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "item-margin"
  }, [_c('mu-flexbox', {
    staticStyle: {
      "margin-left": "40px"
    },
    attrs: {
      "orient": "vertical"
    }
  }, [_c('mu-flexbox-item', {
    staticClass: "item-margin"
  }, [_c('li', {
    staticClass: "oddStyle"
  }, [_vm._v("与患者关系")]), _vm._v(" "), _c('li', {
    staticClass: "evenStyle"
  }, [_vm._v(_vm._s(_vm.contactInfo.relation))])])], 1)], 1)], 1), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('mu-flexbox', {
    staticClass: "box-margin",
    attrs: {
      "align": "flex-start"
    }
  }, [_c('mu-flexbox-item', {
    staticClass: "item-margin"
  }, [_c('mu-flexbox', {
    staticStyle: {
      "margin-left": "40px"
    },
    attrs: {
      "orient": "vertical"
    }
  }, [_c('mu-flexbox-item', {
    staticClass: "item-margin"
  }, [_c('li', {
    staticClass: "oddStyle"
  }, [_vm._v("服药史")]), _vm._v(" "), _vm._l((_vm.pillInfo), function(pill) {
    return _c('ul', [_c('li', {
      staticClass: "evenStyle"
    }, [_vm._v(_vm._s(pill.begin)), (pill.begin != '') ? _c('span', [_vm._v("至")]) : _vm._e(), _vm._v(_vm._s(pill.end))]), _vm._v(" "), _c('li', {
      staticClass: "evenStyle",
      staticStyle: {
        "width": "400px"
      }
    }, [_vm._v(_vm._s(pill.desc))])])
  })], 2), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "item-margin"
  }, [_c('li', {
    staticClass: "oddStyle"
  }, [_vm._v("病史")]), _vm._v(" "), _vm._l((_vm.illInfo), function(ill) {
    return _c('ul', [_c('li', {
      staticClass: "evenStyle"
    }, [_vm._v(_vm._s(ill.begin)), (ill.begin != '') ? _c('span', [_vm._v("至")]) : _vm._e(), _vm._v(_vm._s(ill.end))]), _vm._v(" "), _c('li', {
      staticClass: "evenStyle",
      staticStyle: {
        "width": "400px"
      }
    }, [_vm._v(_vm._s(ill.desc))])])
  })], 2), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "item-margin"
  }, [_c('li', {
    staticClass: "oddStyle"
  }, [_vm._v("家族病史")]), _vm._v(" "), _c('li', {
    staticClass: "evenStyle",
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v(_vm._s(_vm.familyInfo))])]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "item-margin"
  }, [_c('span', {
    staticClass: "pointer changeStyle",
    on: {
      "click": _vm.openModal
    }
  }, [_vm._v("修改/新增")])])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5e27ad35!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/service/case/collectInfo/collectInfo.vue
// module id = 993
// module chunks = 2